import frLocale from 'i18n-iso-countries/langs/fr.json'

export const colorOptions = [
  {
    label: 'Noir et blanc',
    value: 'bw',
  },
  {
    label: 'Couleur',
    value: 'color',
  },
]

export const countriesList = Object.entries(frLocale.countries).map(
  ([_, value]) => {
    return { label: value, value: value }
  }
)

export const letterTypeOptions = [
  {
    label: 'Courrier électronique',
    value: 'electronic',
  },
  {
    label: 'Courrier classique',
    value: 'paper',
  },
]

export const postageTypeOptions = [
  {
    label: 'Ecopli',
    value: 'ecopli',
  },
  {
    label: 'Prioritaire',
    value: 'prioritaire',
  },
  {
    label: 'Lettre recommandée',
    value: 'lr',
  },
  {
    label: 'Lettre recommandée avec accusé de réception',
    value: 'lrar',
  },
]

export const INTRODUCTION_TYPE = 'introduction'
export const ENDING_TYPE = 'ending'
export const SIGNATURE_TYPE = 'signature'
export const BODY_TYPE = 'body'

export const templateTypes = [
  INTRODUCTION_TYPE,
  ENDING_TYPE,
  SIGNATURE_TYPE,
  BODY_TYPE,
]
